/* eslint-disable @typescript-eslint/await-thenable */
/* eslint-disable functional/no-conditional-statement */
import { OrderState } from "../../app/miscellaneous/orderAtom";
import { FinishLoadingInput } from "../../common-loader/hooks/useAsyncLoader";
import { FetchPutOrderOutput } from "./fetchPutOrder";
import { mkHcRequestError } from "./mkHcRequestError";

export async function putOrderSubsetError(
  result: FetchPutOrderOutput
): Promise<FinishLoadingInput<OrderState>> {
  if (result.tag === "client-error") {
    const response = await result.parsed;

    if (response && response.title === "Address Restricted Country") {
      return {
        tag: "errors",
        errors: ["mk-hc-order-error-currency-not-supported"],
        uuid: "9f5fee50-8fc9-4f93-b433-089303e263a5",
      };
    }
  }

  return {
    tag: "errors",
    errors: [mkHcRequestError],
    uuid: "9f5fee50-8fc9-4f93-b433-089303e263a5",
  };
}
